import * as NotificationActions from './actions/notification.actions';
//Valor por defecto
var defaultState = {
    contador: 0
};
//Crear nuevo objeto de estado
var newState = function (state, newData) {
    return Object.assign({}, state, newData);
};
var ɵ0 = newState;
export function notificationReducer(state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case NotificationActions.UPDATE_NOTIFICATION:
            return newState(state, { contador: action.payload });
        default:
            return state;
    }
}
export { ɵ0 };
